import _ from "lodash";

const isEmailDuplicate = (email1, email2) => email1?.toLowerCase() === email2?.toLowerCase();

export const checkDuplicateEmail = (updatedState, passkey, applicantsEmails) => {
    const borrowerEmail = _.get(updatedState, "ApplicantDetails.BorrowerDetails.Email", {});
    const coBorrowerEmail = _.get(updatedState, "ApplicantDetails.CoBorrowerDetails.Email", {});
    const coApplicantDetails = _.get(updatedState, "CoApplicant.CoApplicant", []);
    let hasDuplicate = false;

    if (passkey === "personalInformation") {
        if (applicantsEmails) {
            const matchingItem = applicantsEmails.some(item => isEmailDuplicate(item.email, coBorrowerEmail));
            if (matchingItem) {
                hasDuplicate = true;
            }
        } else {
            const isDuplicateWithBorrower = isEmailDuplicate(coBorrowerEmail, borrowerEmail);
            const isDuplicateWithCoApplicants = coApplicantDetails.some(({ Email }) =>
                isEmailDuplicate(coBorrowerEmail, Email)
            );
            hasDuplicate = isDuplicateWithBorrower || isDuplicateWithCoApplicants
        }
    }
    
    if (passkey === "CoApplicants") {
        const hasDuplicateWithBorrower = coApplicantDetails.some(({ Email }) => isEmailDuplicate(Email, borrowerEmail));
        const hasDuplicateWithCoBorrower = !_.isEmpty(coBorrowerEmail) ? coApplicantDetails.some(({ Email }) => isEmailDuplicate(Email, coBorrowerEmail)) : false;
        const emailSet = new Set();
        const hasDuplicateAmongCoApplicants = coApplicantDetails.some(({ Email }) => {
            if (Email && emailSet.has(Email)) return true;
            emailSet.add(Email);
            return false;
        });
        hasDuplicate = hasDuplicateWithBorrower || hasDuplicateAmongCoApplicants || hasDuplicateWithCoBorrower
    }
    return {
        hasDuplicate
    };
}
export const debouncedCheckDuplicateEmail = _.debounce((updatedState, passkey, applicantsEmails, returnCheck) => {
    const result = checkDuplicateEmail(updatedState, passkey, applicantsEmails);
    returnCheck(result);
}, 800);
